import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { editUsers as editUsersAPI } from 'services/apiUsers';

const useEditUsers = () => {
  
    const queryClient = useQueryClient();
    const {isPending: isEditing,isSuccess: isEdited,mutate: editUsers} = useMutation({
        mutationFn: editUsersAPI,
        onSuccess:(data)=>{
            queryClient.setQueryData(["editedUser"],data)
            queryClient.invalidateQueries({queryKey:["userList"]})
            toast.success('User Updated Sucessfully')
        },
        onError:(error)=>{
            console.log("Login error:", error);
            if (error?.data && typeof error.data === 'object'){
                for (const key in error.data) {
                const messages = error.data[key]
                const message = Array.isArray(messages) ? messages[0] : messages
                toast.error(message)
                }
            }else{
                toast.error("Something went wrong. Please try again.")
            }
        }
    })
    return{isEditing,isEdited,editUsers}
}

export default useEditUsers